import { createContext, useContext } from 'react';

/**
 * Words the storefront draws from code rather than from the shop's document -
 * a theme's own page arrangement (`themePageDefaults`, `themePartDefaults`)
 * and the sections' schema defaults - put through the shop's translation.
 *
 * A live shop needs none: null, and those words read as written. A theme
 * preview in another language provides one (`previewThemes/i18n`), so the
 * product page's "Customer reviews" follows the language like everything else.
 */
export type StorefrontTextTranslator = <T>(value: T) => T;

export const StorefrontTextTranslatorContext = createContext<StorefrontTextTranslator | null>(null);

export function useStorefrontTextTranslator(): StorefrontTextTranslator | null {
  return useContext(StorefrontTextTranslatorContext);
}
